import { APICore } from "./apiCore";

const api = new APICore();

// account
function login(params: { email: string | null; password: string }) {
  const baseUrl = "/login/";
  return api.create(`${baseUrl}`, params);
}

function loginOTP(params: { flow: string; mobileNumber: string | null; email: string | null; otp: string, IsFromOutSide: boolean }) {
  const baseUrl = "/login-otp/";
  return api.create(`${baseUrl}`, params);
}

function loginDetails(params: { details: any | null; }) {
  const baseUrl = "/login-details/";
  return api.create(`${baseUrl}`, params);
}

function logout() {
  const baseUrl = "/logout/";
  return api.create(`${baseUrl}`, {});
}

function signup(params: { fullname: string; email: string | null; password: string }) {
  const baseUrl = "/register/";
  return api.create(`${baseUrl}`, params);
}

function forgotPassword(params: { email: string | null }) {
  const baseUrl = "/forget-password/";
  return api.create(`${baseUrl}`, params);
}

export { loginOTP, login, loginDetails, logout, signup, forgotPassword };
